import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { makeStyles } from '../styles';
const useStyles = makeStyles(() => ({
    box: {
        display: 'flex',
        justifyContent: ({ justifyContent }) => justifyContent,
        alignItems: ({ alignItems }) => alignItems,
        flexGrow: ({ flexGrow }) => flexGrow,
    },
    none: {},
    row: {
        margin: 0,
        flexDirection: 'row',
    },
    column: {
        padding: 0,
        flexDirection: 'column',
    },
    rowReverse: {
        padding: 0,
        flexDirection: 'row-reverse',
    },
    clickable: {
        cursor: 'pointer',
    },
}));
const Box = forwardRef(({ children, flexDirection = 'none', justifyContent = 'flex-start', width, alignItems = 'stretch', height, minWidth, maxWidth, flexGrow, className, onClick, }, ref) => {
    const classes = useStyles({ justifyContent, alignItems, flexGrow });
    return (React.createElement("div", { ref: ref, className: classNames(className, classes.box, classes[flexDirection], {
            [classes.clickable]: onClick,
        }), style: { height, width, minWidth, maxWidth }, onClick: onClick }, children));
});
export default Box;
//# sourceMappingURL=Box.js.map